import { getHours, getMinutes } from 'date-fns';

export const makeDateFromTime = (data) => {
  const { high, low } = get_high_low(data);
  var Date_made = new Date(2023, 0, 1, high, low, 21, 22);
  return Date_made;
};

export const get_high_low = (value) => {
  const hh = (value & 0xff00) >> 8;
  const ll = value & 0x00ff;

  return {
    high: hh,
    low: ll,
  };
};

// Inverse of get_high_low/makeDateFromTime: packs a Date's hour/minute back
// into the same hi/lo register integer, mirroring the encoding used for
// writing time registers elsewhere (DeviceView.js's handleTimesUpdate,
// deviceState.js's start/end time packing).
export const makeTimeFromDate = (date) => {
  return (getHours(date) << 8) | getMinutes(date);
};
